// Port of api/fuel/app/classes/filter/search/games/rules/query/total_plays.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'total_plays',
	field: function() { return 'COALESCE(SUM(p.play_count), 0)' },
	pre: function(rule, config, filter, data, query) {
		query.where('p.user_id', 'in', data.users)
		query.join('play', 'p', 'LEFT JOIN')
		query.leftjoin('p', true)
	}
})
